import { getUnionValues, type UnionRecord } from '../validation'

const ledgerTypeValues: UnionRecord<LedgerType> = {
  ADMINISTRATOR_COMMISSION: null,
  ADVISOR_CONVEYANCING_COMMISSION: null,
  ADVISOR_GENERAL_INSURANCE_COMMISSION: null,
  ADVISOR_MORTGAGE_COMMISSION: null,
  ADVISOR_PROTECTION_COMMISSION: null,
  ADVISOR_MORTGAGE_TIER_COMMISSION: null,
  ADVISOR_PROTECTION_TIER_COMMISSION: null,
  CASE_MANAGER_COMMISSION: null,
  CLAWBACK: null,
  CLUB_FEE: null,
  CONVEYANCING_REFERRAL_FEE: null,
  GENERAL_INSURANCE_PROC_FEE: null,
  INTRODUCER_GENERAL_INSURANCE_COMMISSION: null,
  INTRODUCER_MORTGAGE_COMMISSION: null,
  INTRODUCER_PROTECTION_COMMISSION: null,
  LAND_REGISTRY_REPORT_FEE: null,
  LEAD_QUALIFIER_COMMISSION: null,
  MASTER_BROKER_REFERRAL_FEE: null,
  MORTGAGE_PROC_FEE: null,
  MORTGAGE_LEGAL_COMPLETION_COMBINED: null,
  MORTGAGE_LEGAL_COMPLETION_FIXED: null,
  MORTGAGE_LEGAL_COMPLETION_PERCENTAGE: null,
  MORTGAGE_LEGAL_EXCHANGE_COMBINED: null,
  MORTGAGE_LEGAL_EXCHANGE_FIXED: null,
  MORTGAGE_LEGAL_EXCHANGE_PERCENTAGE: null,
  MORTGAGE_OFFER_COMBINED: null,
  MORTGAGE_OFFER_FIXED: null,
  MORTGAGE_OFFER_PERCENTAGE: null,
  MORTGAGE_REFERENCE_FEE: null,
  OTHER_REFERRAL_FEE: null,
  PENSION_REFERRAL_FEE: null,
  POST_MORTGAGE_APPLICATION_COMBINED: null,
  POST_MORTGAGE_APPLICATION_FIXED: null,
  POST_MORTGAGE_APPLICATION_PERCENTAGE: null,
  PRE_MORTGAGE_ADVICE_COMBINED: null,
  PRE_MORTGAGE_ADVICE_FIXED: null,
  PRE_MORTGAGE_ADVICE_PERCENTAGE: null,
  PRE_MORTGAGE_APPLICATION_COMBINED: null,
  PRE_MORTGAGE_APPLICATION_FIXED: null,
  PRE_MORTGAGE_APPLICATION_PERCENTAGE: null,
  PRE_MORTGAGE_RECOMMENDATION_COMBINED: null,
  PRE_MORTGAGE_RECOMMENDATION_FIXED: null,
  PRE_MORTGAGE_RECOMMENDATION_PERCENTAGE: null,
  PROTECTION_PROC_FEE: null,
  REFERRER_COMMISSION: null,
  RELATED_USER_COMMISSION: null,
  REVIEWER_COMMISSION: null,
  VALUATION_FEE: null,
  WATCHER_COMMISSION: null,
  WILL_REFERRAL_FEE: null,
}

export default getUnionValues(ledgerTypeValues)
